import React from 'react';
import { bool, shape, string } from 'prop-types';

const FieldsMonitoring2 = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 5.25C10.6 5.25 11.5 4.35 11.5 3.25C11.5 2.15 10.6 1.25 9.5 1.25C8.4 1.25 7.5 2.15 7.5 3.25C7.5 4.35 8.4 5.25 9.5 5.25Z" fill="currentColor" />
    <path d="M5.75 8.65L3 22.75H5.1L6.85 14.75L9 16.75V22.75H11V15.2L8.95 13.15L9.55 10.15C10.85 11.75 12.8 12.75 15 12.75V10.75C13.15 10.75 11.55 9.75 10.65 8.3L9.7 6.7C9.35 6.1 8.7 5.75 8 5.75C7.75 5.75 7.5 5.8 7.25 5.9L2 8.05V12.75H4V9.4L5.75 8.65Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.5 17.7455C14.5 15.6763 16.1796 14 18.25 14C20.3204 14 22 15.6763 22 17.7455C22 19.3717 20.9628 20.7543 19.5148 21.2724C19.399 21.4871 19.2298 21.7883 19.0781 22.0559C18.974 22.2397 18.8753 22.4125 18.8027 22.5393L18.6834 22.7474L18.6819 22.75H17.8181L17.8166 22.7474L17.6971 22.5389C17.6244 22.4119 17.5256 22.2388 17.4214 22.0549C17.2698 21.7874 17.1008 21.4865 16.9852 21.2725C15.5372 20.7543 14.5 19.3717 14.5 17.7455ZM18.25 21.4888C18.447 21.1405 18.6451 20.7851 18.7196 20.6362L18.8171 20.4415L19.0261 20.3803C20.1678 20.0457 21 18.9917 21 17.7455C21 16.2299 19.7694 15 18.25 15C16.7306 15 15.5 16.2299 15.5 17.7455C15.5 18.9917 16.3322 20.0457 17.4739 20.3803L17.6829 20.4415L17.7804 20.6362C17.8544 20.7841 18.0527 21.1399 18.25 21.4888Z" fill="currentColor" />
  </svg>
);

FieldsMonitoring2.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default FieldsMonitoring2;
